"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="ContactAccountData.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxContactAccountData object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxContactAccountData = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxContactAccountData = /** @class */ (function (_super) {
    __extends(HxContactAccountData, _super);
    function HxContactAccountData(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxContactAccountData, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxContactAccountData.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '639':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case '152D':
                        this.accountContactSearchSessionId = new HxObjectID_1.default(v);
                        break;
                    case '67B':
                        this.accountName = v;
                        break;
                    case '127D':
                        this.canCreateContents = v;
                        break;
                    case '6B9':
                        this.capabilities_DescriptionsSupported = v;
                        break;
                    case '6BA':
                        this.capabilities_MaxAnniversaryDatesSupported = v;
                        break;
                    case '6BB':
                        this.capabilities_MaxAssistantPhoneNumbersSupported = v;
                        break;
                    case '6BC':
                        this.capabilities_MaxBirthdayDatesSupported = v;
                        break;
                    case '6BD':
                        this.capabilities_MaxBusinessFaxPhoneNumbersSupported = v;
                        break;
                    case '6BE':
                        this.capabilities_MaxChildRelationshipsSupported = v;
                        break;
                    case '6BF':
                        this.capabilities_MaxCompanyPhoneNumbersSupported = v;
                        break;
                    case '6C0':
                        this.capabilities_MaxHomeAddressesSupported = v;
                        break;
                    case '6C1':
                        this.capabilities_MaxHomeFaxPhoneNumbersSupported = v;
                        break;
                    case '6C2':
                        this.capabilities_MaxHomePhoneNumbersSupported = v;
                        break;
                    case '6C3':
                        this.capabilities_MaxJobInfoSupported = v;
                        break;
                    case '6C4':
                        this.capabilities_MaxMobilePhoneNumbersSupported = v;
                        break;
                    case '6C5':
                        this.capabilities_MaxOtherAddressesSupported = v;
                        break;
                    case '6C6':
                        this.capabilities_MaxOtherDatesSupported = v;
                        break;
                    case '6C7':
                        this.capabilities_MaxOtherEmailAddressesSupported = v;
                        break;
                    case '6C8':
                        this.capabilities_MaxOtherPhoneNumbersSupported = v;
                        break;
                    case '6C9':
                        this.capabilities_MaxOtherRelationshipsSupported = v;
                        break;
                    case '6CA':
                        this.capabilities_MaxPagerPhoneNumbersSupported = v;
                        break;
                    case '6CB':
                        this.capabilities_MaxParentRelationshipsSupported = v;
                        break;
                    case '6CC':
                        this.capabilities_MaxPartnerRelationshipsSupported = v;
                        break;
                    case '6CD':
                        this.capabilities_MaxPersonalEmailAddressesSupported = v;
                        break;
                    case '6CE':
                        this.capabilities_MaxRadioPhoneNumbersSupported = v;
                        break;
                    case '6CF':
                        this.capabilities_MaxSiblingRelationshipsSupported = v;
                        break;
                    case '6D0':
                        this.capabilities_MaxSpouseRelationshipsSupported = v;
                        break;
                    case '6D1':
                        this.capabilities_MaxWebsitesSupported = v;
                        break;
                    case '6D2':
                        this.capabilities_MaxWorkAddressesSupported = v;
                        break;
                    case '6D3':
                        this.capabilities_MaxWorkEmailAddressesSupported = v;
                        break;
                    case '6D4':
                        this.capabilities_MaxWorkPhoneNumbersSupported = v;
                        break;
                    case 'D30':
                        this.changeKey = Buffer.from(v, 'base64');
                        break;
                    case '142A':
                        this.contactCategoriesId = new HxObjectID_1.default(v);
                        break;
                    case '1460':
                        var contactCategoryFilterValues = v;
                        this.contactCategoryFilter = new Array(contactCategoryFilterValues.length);
                        for (var i = 0; i < contactCategoryFilterValues.length; i++) {
                            this.contactCategoryFilter[i] = contactCategoryFilterValues[i];
                        }
                        break;
                    case '63A':
                        this.contactsId = new HxObjectID_1.default(v);
                        break;
                    case '1461':
                        this.contactsSatisfyingCategoriesId = new HxObjectID_1.default(v);
                        break;
                    case '63B':
                        this.contactSyncStatesId = new HxObjectID_1.default(v);
                        break;
                    case 'D39':
                        this.folderUri = v;
                        break;
                    case '635':
                        this.lastAttemptedSyncTime = new Date(v);
                        break;
                    case '636':
                        this.lastSuccessfulSyncTime = new Date(v);
                        break;
                    case '67C':
                        this.networkSourceId = v;
                        break;
                    case '932':
                        this.remoteIdentificationInformationHash = v;
                        break;
                    case '637':
                        this.status = v;
                        break;
                    case 'D31':
                        this.syncToken = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxContactAccountData.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxContactAccountData.prototype.getAccountContactSearchSession = function (sessionId) {
        return this.activeSet.getObject(this.accountContactSearchSessionId, sessionId).then(function (result) { return result; });
    };
    HxContactAccountData.prototype.getContactCategories = function (sessionId) {
        return this.activeSet.getCollection(this.contactCategoriesId, sessionId);
    };
    HxContactAccountData.prototype.getContacts = function (sessionId) {
        return this.activeSet.getCollection(this.contactsId, sessionId);
    };
    HxContactAccountData.prototype.getContactsSatisfyingCategories = function (sessionId) {
        return this.activeSet.getCollection(this.contactsSatisfyingCategoriesId, sessionId);
    };
    HxContactAccountData.prototype.getContactSyncStates = function (sessionId) {
        return this.activeSet.getCollection(this.contactSyncStatesId, sessionId);
    };
    return HxContactAccountData;
}(HxObject_1.default));
exports.HxContactAccountData = HxContactAccountData;
exports.default = HxContactAccountData;
